import Cast from 'scratch-vm/src/util/cast';

class CIPLedBlock {
    constructor() {
        this.ledKeys = [
            {
                text: 'A',
                value: '003c66667e666666'
            },
            {
                text: 'B',
                value: '003e66663e66663e'
            },
            {
                text: 'C',
                value: '003c66060606663c'
            },
            {
                text: 'D',
                value: '003e66666666663e'
            },
            {
                text: 'E',
                value: '007e06063e06067e'
            },
            {
                text: 'F',
                value: '007e06063e060606'
            },
            {
                text: 'G',
                value: '003c66060676663c'
            },
            {
                text: 'H',
                value: '006666667e666666'
            },
            {
                text: 'I',
                value: '003c18181818183c'
            },
            {
                text: 'J',
                value: '007830303036361c'
            },
            {
                text: 'K',
                value: '0066361e0e1e3666'
            },
            {
                text: 'L',
                value: '000606060606067e'
            },
            {
                text: 'M',
                value: '00c6eefed6c6c6c6'
            },
            {
                text: 'N',
                value: '00c6cedef6e6c6c6'
            },
            {
                text: 'O',
                value: '003c66666666663c'
            },
            {
                text: 'P',
                value: '003e6666663e0606'
            },
            {
                text: 'Q',
                value: '003c666666763c60'
            },
            {
                text: 'R',
                value: '003e66663e1e3666'
            },
            {
                text: 'S',
                value: '003c66063c60663c'
            },
            {
                text: 'T',
                value: '007e5a1818181818'
            },
            {
                text: 'U',
                value: '006666666666667c'
            },
            {
                text: 'V',
                value: '0066666666663c18'
            },
            {
                text: 'W',
                value: '00c6c6c6d6feeec6'
            },
            {
                text: 'X',
                value: '00c6c66c386cc6c6'
            },
            {
                text: 'Y',
                value: '006666663c181818'
            },
            {
                text: 'Z',
                value: '007e6030180c067e'
            },
            {
                text: '1',
                value: '0018181c1818187e'
            },
            {
                text: '2',
                value: '003c6660300c067e'
            },
            {
                text: '3',
                value: '003c66603860663c'
            },
            {
                text: '4',
                value: '00303834327e3030'
            },
            {
                text: '5',
                value: '007e063e6060663c'
            },
            {
                text: '6',
                value: '003c66063e66663c'
            },
            {
                text: '7',
                value: '007e663030181818'
            },
            {
                text: '8',
                value: '003c66663c66663c'
            },
            {
                text: '9',
                value: '003c66667c60663c'
            },
            {
                text: '0',
                value: '003c66766e66663c'
            },
            {
                text: 'SMILE1',
                value: '0066660000427e3c'
            },
            {
                text: 'SMILE2',
                value: '0042e7420081663c'
            },
            {
                text: 'SMILE3',
                value: '3c42a581a599423c'
            },
            {
                text: 'SMILE4',
                value: 'ffffc3a500423c00'
            },
            {
                text: 'HAPPY',
                value: '00006600423c0000'
            },
            {
                text: 'CRY',
                value: '0000e7c3003c4200'
            },
            {
                text: 'ANGRY',
                value: '4224006666001824'
            },
            {
                text: 'SAD',
                value: '3c42a581bd81423c'
            },
            {
                text: 'SUN',
                value: '00281a7c3e581400'
            },
            {
                text: 'MOON',
                value: '00381c0c0c1c3800'
            },
            {
                text: 'SQUARE',
                value: '007e7e7e7e7e7e00'
            },
            {
                text: 'CIRCLE',
                value: '003c7e7e7e7e3c00'
            },
            {
                text: 'TRIANGLE',
                value: '0002060e1e3e7e00'
            },
            {
                text: 'FLOWER',
                value: '3c3cdbe7e7db3c3c'
            },
            {
                text: 'HEART',
                value: '0066ffffff7e3c18'
            },
            {
                text: '8ANGLES',
                value: '00183c7e7e3c1800'
            },
            {
                text: 'EXCLAMATION',
                value: '00183c3c3c180018'
            },
            {
                text: 'QUESTION',
                value: '003c666038180018'
            },
            {
                text: 'STAR',
                value: '0018187e7e3c6600'
            },
            {
                text: 'MINUS',
                value: '0000007e7e000000'
            },
            {
                text: 'PLUS',
                value: '0018187e7e181800'
            },
            {
                text: 'MULTIPLY',
                value: '00666e1c38766600'   
            },
            {
                text: 'DIVISION',
                value: '0018007e7e001800'
            },
            {
                text: 'DURK',
                value: '70c88810205f7e3c'
            },
            {
                text: 'NOTE1',
                value: '000c0a0808183830'
            },
            {
                text: 'NOTE2',
                value: '001e3222266eecc0'
            },
            {
                text: 'O',
                value: '3c7ee7c3c3e77e3c'
            },
            {
                text: 'X',
                value: 'c3e77e3c3c7ee7c3'
            },
            {
                text: 'FULL',
                value: 'ffffffffffffffff'
            },
            {
                text: 'FORWARD',
                value: '00183c5a18181800' 
            },
            {
                text: 'BACKWARD',
                value: '001818185a3c1800'
            },
            {
                text: 'RIGHT',
                value: '0010207e7e201000'
            },
            {
                text: 'LEFT',
                value: '0008047e7e040800'
            },
            {
                text: 'CLEAR',
                value: '0000000000000000'
            }
        ];

    }

    ledControl (ledBlock, matrixHex) {
        if (!ledBlock) {
            return {
                result: false,
                error: '[Error] The led block is not connected.',
            };
        }

        ledBlock.ledControl(matrixHex);

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    ledDisplay(ledBlock, key) {
        if (!ledBlock) {
            return {
                result: false,
                error: '[Error] The led block is not connected.',
            };
        }

        const ledKey = Cast.toString(key).toUpperCase();

        const data = this.ledKeys.find((lk) => lk.text === ledKey) ?? this.ledKeys[this.ledKeys.length - 1];

        ledBlock.ledControl(data.value);

        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }
}

export default CIPLedBlock;
